import { AbstractControl, ValidationErrors } from '@angular/forms';

export function urlValidator({ value }: AbstractControl): ValidationErrors | null {
    try {
      new URL(value);
    } catch {
      return { invalidUrl: true };
    }

    return null;
}
